import { MenuItem, Select, Box } from '@mui/material';
import typography from '../../styles/typography.module.css';
import layout from '../../styles/layout.module.css';
import { useTranslation } from 'react-i18next';

const TextOnCaseDropdown = ({ handleChange, required, type, currValue }) => {
    const { t } = useTranslation();
    const textOnCaseLabels = [
        { label: t('finalize.text_on_case_no'), value: false },
        { label: t('finalize.text_on_case_yes'), value: true }
    ];
    const renderedDropdownOptions = textOnCaseLabels.map((option) => {
        return (
            <MenuItem
                key={option.value}
                name={option.label}
                label={option.label}
                value={option.value}>
                {option.label}
            </MenuItem>
        );
    });

    return (
        <Box className={layout.finalizeSectionContainer}>
            <h4 className={typography.finalizeTitle} style={{ textAlign: 'initial' }}>
                {type}
                {required && <span style={{ color: 'red' }}>*</span>}
            </h4>
            <Select
                style={{ width: '100%', height: '40px', marginBottom: '5px' }}
                defaultValue={currValue}
                displayEmpty
                onChange={(event) => {
                    event.preventDefault();
                    handleChange(event.target.value);
                }}>
                <MenuItem disabled value="">
                    <em>{t('finalize.select_one')}</em>
                </MenuItem>
                {renderedDropdownOptions}
            </Select>
        </Box>
    );
};

export default TextOnCaseDropdown;
